// Temple University's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official Temple University Bulletin 2026-2027
// (bulletin.temple.edu/undergraduate/), one page per school or college. Each
// school's page lists its programs by name and degree (e.g. "Accounting BBA",
// "Advertising BA with Account Management Concentration"); every bachelor's
// line is kept as the Bulletin lists it, concentrations included, with the
// degree split out. Left out: minors, certificates, the General Program AA,
// non-degree entry programs (Pre-Nursing Entry Program, Engineering
// (Undeclared), BFA Foundation), accelerated bachelor's/master's programs, and
// the Intercollegial Programs page, whose Mathematical Economics BA is listed
// under both Liberal Arts and Science and Technology. Programs the Bulletin
// marks (TUJ) are taught at Temple University, Japan Campus and carry that
// note. The Bulletin's "(CLA)" and "(CST)" tags on Mathematical Economics are
// dropped, since the group already names the college.
const majors = {
    "slug": "temple-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Temple's official 2026-2027 Undergraduate Bulletin, grouped by the school or college that offers it, with the degree it leads to. The Bulletin lists each concentration as its own program, so they appear here as it lists them. Minors, certificates, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "Boyer College of Music and Dance",
            "source": {
                "label": "Temple University Bulletin 2026-2027, Boyer College of Music and Dance",
                "url": "https://bulletin.temple.edu/undergraduate/boyer-music-dance/"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Jazz Studies/Composition",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies/Performance",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies/Performance with Piano Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies/Performance with Voice Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music Education/Jazz",
                    "degree": "BM"
                },
                {
                    "name": "Music History",
                    "degree": "BM"
                },
                {
                    "name": "Music Technology",
                    "degree": "BS"
                },
                {
                    "name": "Music Technology with Interdisciplinary Studies Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy/Jazz",
                    "degree": "BM"
                },
                {
                    "name": "Performance",
                    "degree": "BM"
                },
                {
                    "name": "Performance with Classical Guitar Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Performance with Harpsichord Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Performance with Piano Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Performance with Voice Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Theory",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "Temple University Bulletin 2026-2027, College of Education and Human Development",
                "url": "https://bulletin.temple.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Adult Learning, Training and Organizational Development",
                    "degree": "BA"
                },
                {
                    "name": "Career and Technical Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Career and Technical Education with Business, Computer and Information Technology Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Career and Technical Education with Marketing Education Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Early and Elementary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Early and Elementary Education with Special Education Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Human Development and Community Engagement",
                    "degree": "BS"
                },
                {
                    "name": "Middle Grades Education with Language Arts Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Mathematics and Language Arts Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Mathematics and Science Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Mathematics Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Science and Language Arts Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Science Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades Education with Social Studies Concentration",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education / English Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education / Mathematics Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education / Social Studies Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education / World Languages Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Special Education (Pre-K-12)",
                    "degree": "BSEd"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Temple University Bulletin 2026-2027, College of Engineering",
                "url": "https://bulletin.temple.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Bioengineering with Cellular Engineering Concentration",
                    "degree": "BSBIOE"
                },
                {
                    "name": "Bioengineering with Engineering Devices Concentration",
                    "degree": "BSBIOE"
                },
                {
                    "name": "Bioengineering with Pre-Health Concentration",
                    "degree": "BSBIOE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering with Cooperative Education Program Concentration",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering with Environmental Engineering & Cooperative Education Program Concentrations",
                    "degree": "BSCE"
                },
                {
                    "name": "Civil Engineering with Environmental Engineering Concentration",
                    "degree": "BSCE"
                },
                {
                    "name": "Construction Engineering Technology",
                    "degree": "BSCET"
                },
                {
                    "name": "Construction Engineering Technology with Cooperative Education Program Concentration",
                    "degree": "BSCET"
                },
                {
                    "name": "Electrical and Computer Engineering with Bioelectrical Engineering Concentration",
                    "degree": "BSECE"
                },
                {
                    "name": "Electrical and Computer Engineering with Computer Engineering Concentration",
                    "degree": "BSECE"
                },
                {
                    "name": "Electrical and Computer Engineering with Electrical Engineering Concentration",
                    "degree": "BSECE"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Engineering Technology with Mechanical Engineering Technology Concentration",
                    "degree": "BSET"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BSISE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering with Cooperative Education Program Concentration",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BSMET"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Temple University Bulletin 2026-2027, College of Liberal Arts",
                "url": "https://bulletin.temple.edu/undergraduate/liberal-arts/"
            },
            "majors": [
                {
                    "name": "Africology and African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics with Classical Civilizations Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Classics with Classical Languages and Literature Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Cybersecurity and Human Behavior",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender, Sexuality and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Program",
                    "degree": "BA"
                },
                {
                    "name": "Geography and Urban Studies",
                    "degree": "BA"
                },
                {
                    "name": "German Language and Cultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary German Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "International Business Studies",
                    "degree": "BS"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience: Systems, Behavior and Plasticity",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Studies",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "Temple University Bulletin 2026-2027, College of Public Health",
                "url": "https://bulletin.temple.edu/undergraduate/public-health/"
            },
            "majors": [
                {
                    "name": "Exercise and Sport Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Information Management",
                    "degree": "BSHIM"
                },
                {
                    "name": "Health Professions",
                    "degree": "BS"
                },
                {
                    "name": "Health Studies",
                    "degree": "BA"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nursing Accelerated",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Speech, Language and Hearing Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Science and Technology",
            "source": {
                "label": "Temple University Bulletin 2026-2027, College of Science and Technology",
                "url": "https://bulletin.temple.edu/undergraduate/science-technology/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science with Computation and Modeling Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Data Science with Computational Analytics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Data Science with Genomics and Bioinformatics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Space Science with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Ecology, Evolution and Biodiversity",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science with Applied Ecology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science with Climate Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science with Environmental Geochemistry Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science with Hydrology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "General Science and Mathematics with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "General Science and Technology with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "General Science with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Genomic Medicine",
                    "degree": "BS"
                },
                {
                    "name": "Genomic Medicine with Pre-Medicine Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "BA"
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Integrative Genetics and Genomics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Technology with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Natural Sciences with Biology Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences with Chemistry Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences with Earth and Environmental Sciences Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences with Physics Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences with Biology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Natural Sciences with Chemistry Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Natural Sciences with Earth and Environmental Sciences Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Natural Sciences with Physics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience: Cellular and Molecular",
                    "degree": "BS"
                },
                {
                    "name": "Pharmaceutical Studies",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics with Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Quantum Materials Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Fox School of Business and Management",
            "source": {
                "label": "Temple University Bulletin 2026-2027, Fox School of Business and Management",
                "url": "https://bulletin.temple.edu/undergraduate/fox-business-management/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Accounting with Data Analytics Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BBA"
                },
                {
                    "name": "Business Management",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship and Innovation Management",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Financial Planning",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Economics Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Entrepreneurship Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Finance Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Marketing Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Sales and Business Development Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "International Business with International Supply Chain Management, Transportation and Logistics",
                    "degree": "BBA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance with Healthcare Risk Management Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance with Managing Corporate Risk Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance with Managing Human Capital Risk Concentration",
                    "degree": "BBA"
                },
                {
                    "name": "Statistical Science and Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Lew Klein College of Media and Communication",
            "source": {
                "label": "Temple University Bulletin 2026-2027, Lew Klein College of Media and Communication",
                "url": "https://bulletin.temple.edu/undergraduate/media-communication/"
            },
            "majors": [
                {
                    "name": "Advertising with Account Management Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Advertising with Art Direction Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Advertising with Brand Strategy and Research Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Advertising with Copywriting Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Advertising with Media Planning Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Audio and Live Entertainment",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication with Pre-Law Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies with Communication and Entrepreneurship Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies with Communication Studies Thesis Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies with Contemporary Media Environments Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies with Global and Community Engagement Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies with Production Concentration",
                    "degree": "BA",
                    "note": "Temple University, Japan Campus"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies and Production with Media Analysis Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies and Production with Media Business Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies and Production with Media Production Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                },
                {
                    "name": "Virtual Media Management",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "Temple University Bulletin 2026-2027, School of Pharmacy",
                "url": "https://bulletin.temple.edu/undergraduate/pharmacy/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Temple University Bulletin 2026-2027, School of Social Work",
                "url": "https://bulletin.temple.edu/undergraduate/social-work/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "School of Sport, Tourism and Hospitality Management",
            "source": {
                "label": "Temple University Bulletin 2026-2027, School of Sport, Tourism and Hospitality Management",
                "url": "https://bulletin.temple.edu/undergraduate/tourism-hospitality-management/"
            },
            "majors": [
                {
                    "name": "Multidisciplinary Studies in Sport, Tourism, Hospitality and Event Management",
                    "degree": "BS"
                },
                {
                    "name": "Sport and Entertainment Management",
                    "degree": "BS"
                },
                {
                    "name": "Tourism, Hospitality and Event Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Theater, Film and Media Arts",
            "source": {
                "label": "Temple University Bulletin 2026-2027, School of Theater, Film and Media Arts",
                "url": "https://bulletin.temple.edu/undergraduate/theater-film-media-arts/"
            },
            "majors": [
                {
                    "name": "Film and Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Arts with Cinematography Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Arts with Post Production Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Arts with Producing Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Arts with Screen Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Arts with Animation and Media Arts Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Media Arts with Directing Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Media Arts with Screenwriting Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Musical Theater",
                    "degree": "BFA"
                },
                {
                    "name": "Technical Production and Management",
                    "degree": "BFA"
                },
                {
                    "name": "Theater",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Tyler School of Art and Architecture",
            "source": {
                "label": "Temple University Bulletin 2026-2027, Tyler School of Art and Architecture",
                "url": "https://bulletin.temple.edu/undergraduate/tyler/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BSArch"
                },
                {
                    "name": "Art",
                    "degree": "BA",
                    "note": "Temple University, Japan Campus"
                },
                {
                    "name": "Art with Graphic Design Concentration",
                    "degree": "BA",
                    "note": "Temple University, Japan Campus"
                },
                {
                    "name": "Art Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Therapy",
                    "degree": "BA"
                },
                {
                    "name": "Ceramics",
                    "degree": "BFA"
                },
                {
                    "name": "Community Development",
                    "degree": "BS"
                },
                {
                    "name": "Facilities Management",
                    "degree": "BS"
                },
                {
                    "name": "Fibers and Material Studies",
                    "degree": "BFA"
                },
                {
                    "name": "Glass",
                    "degree": "BFA"
                },
                {
                    "name": "Graphic and Interactive Design",
                    "degree": "BFA"
                },
                {
                    "name": "Historic Preservation",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Illustration and Emerging Media",
                    "degree": "BFA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture with Horticulture Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Metals/Jewelry/CAD-CAM",
                    "degree": "BFA"
                },
                {
                    "name": "Painting",
                    "degree": "BFA"
                },
                {
                    "name": "Photography",
                    "degree": "BFA"
                },
                {
                    "name": "Printmaking",
                    "degree": "BFA"
                },
                {
                    "name": "Sculpture",
                    "degree": "BFA"
                },
                {
                    "name": "User Experience and User Interface Design",
                    "degree": "BFA"
                },
                {
                    "name": "Visual Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "Temple University Bulletin 2026-2027, University College",
                "url": "https://bulletin.temple.edu/undergraduate/university-college/"
            },
            "majors": [
                {
                    "name": "General Studies",
                    "degree": "BGS"
                }
            ]
        }
    ]
};

export default majors;
